import { render } from "./LoadingScreen.vue?vue&type=template&id=829d0618&scoped=true&ts=true"
import script from "./loading-screen.component.ts?vue&type=script&lang=ts&external"
export * from "./loading-screen.component.ts?vue&type=script&lang=ts&external"

import "./loading-screen.scss?vue&type=style&index=0&id=829d0618&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829d0618"]])

export default __exports__